import { MAINNET_RELAY_API } from '@relayprotocol/relay-sdk'
import type { RelayAddress } from './execution'
import type { RelayTokenPriceInfo } from './types'
import {
  convertFunToRelayChainId,
  convertFunToRelayTokenAddress,
  filterNullishHeaders,
} from './utils'

interface GetRelayAssetPriceInfoParams {
  chainId: string
  address: string
  apiKey?: string
}

export async function getRelayAssetPriceInfo({
  chainId,
  address,
  apiKey,
}: GetRelayAssetPriceInfoParams): Promise<RelayTokenPriceInfo> {
  const relayChainId = convertFunToRelayChainId(Number(chainId))
  const relayTokenAddress = convertFunToRelayTokenAddress(
    address as RelayAddress,
    relayChainId,
  )

  const url = `${MAINNET_RELAY_API}/currencies/token/price?chainId=${relayChainId}&address=${relayTokenAddress}`
  const headers = filterNullishHeaders({ 'x-api-key': apiKey })
  const response = await fetch(url, { headers })

  if (!response.ok) {
    throw Error(response.statusText)
  }

  const data = await response.json()
  return data as RelayTokenPriceInfo
}
